export const APP_VERSION = "1.18.36";
